var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.617 1.66602H6.39199C3.56699 1.66602 1.66699 3.64935 1.66699 6.59935V13.4085C1.66699 16.3502 3.56699 18.3327 6.39199 18.3327H13.617C16.442 18.3327 18.3337 16.3502 18.3337 13.4085V6.59935C18.3337 3.64935 16.442 1.66602 13.617 1.66602Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.509 11.4748C12.7923 11.7582 12.7923 12.2165 12.509 12.499C12.3673 12.6407 12.184 12.7165 11.9923 12.7165C11.809 12.7165 11.6257 12.6498 11.484 12.499L10.0007 11.0248L8.51732 12.499C8.37565 12.6407 8.19232 12.7165 8.00065 12.7165C7.81732 12.7165 7.62565 12.6407 7.48398 12.499C7.20065 12.2165 7.20065 11.7582 7.48398 11.4665L8.96732 9.99151L7.48398 8.50734C7.20065 8.22484 7.20065 7.75818 7.48398 7.47484C7.76732 7.19068 8.22565 7.19068 8.51732 7.47484L10.0007 8.95734L11.4757 7.47484C11.7673 7.19068 12.2257 7.19068 12.509 7.47484C12.7923 7.75818 12.7923 8.22484 12.509 8.50734L11.0257 9.99151L12.509 11.4748Z",
    fill: "#FF5630"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/closeWhite.7a8c2e11.svg";
export { ForwardRef as ReactComponent };